import { createPinia } from 'pinia'
import piniaPluginPersist from 'pinia-plugin-persist'

export * from './modules/userInfo'
import type { App } from 'vue'
export function setupStore(app: App<Element>): void {
  const pinia = createPinia()
  pinia.use(piniaPluginPersist)
  app.use(pinia)
}
